// ReadOnlyView.js - Simplified read-only view
import React from 'react';
import './ReadOnlyView.css';
import { Lock } from '@mui/icons-material';

const ReadOnlyView = ({ task, userRole }) => {
  return (
    <div className="readonly">
      <div className="readonly__content">
        <div className="readonly__icon">
          <Lock />
        </div>
        <h1 className="readonly__title">This task is currently unavailable </h1>
      </div>
    </div>
  );
};

export default ReadOnlyView;